import dayjs from "dayjs";
import Parse from "parse";
import {
  ParseDateRestType,
  ParsePointerRestType,
} from "../types/ArrayValueInputDataTypes";
import { FormValues, Operation } from "../types/FormValues";
import { isRelationOperator } from "../types/Operations";

/**
 * Converts form values to a Parse.Query object.
 * @param values Form Values of the ParseQueryForm - Component.
 * @returns Parse.Query object.
 */
export const convertFormToQuery = (values: FormValues) => {
  if (!values.className) return null;
  const query = new Parse.Query(values.className).select(values.keys);
  if (typeof values.limit !== "number") query.limit(-1);
  if (typeof values.skip !== "number") query.skip(0);

  for (const key in values.operations) {
    addOperationToQuery(query, values.operations[key]);
  }

  return query;
};

/**
 * Adds an operation to the query configured in the form.
 * @param query the query object to add the operation to.
 * @param operation the operation to add to the query.
 */
function addOperationToQuery(query: Parse.Query, operation: Operation) {
  // The converted value is the value of the operation, if the operation is a relation operation, the value should be the query object.
  let convertedValue = operation.value?.query ?? operation.value;
  convertedValue =
    !isRelationOperator(operation.operator) && operation.field.type === "number"
      ? Number(operation.value)
      : convertedValue;

  try {
    // handle relation operations
    if (isRelationOperator(operation.operator)) {
      convertedValue = convertFormToQuery(convertedValue);
      switch (operation.operator) {
        case "matchesQuery":
          query.matchesQuery(
            operation.field.value,
            convertFormToQuery(convertedValue)
          );
          break;
        case "doesNotMatchQuery":
          query.doesNotMatchQuery(operation.field.value, convertedValue);
          break;
        case "matchesKeyInQuery":
          query.matchesKeyInQuery(
            operation.field.value,
            operation.value.key,
            convertedValue
          );
          break;
        case "doesNotMatchKeyInQuery":
          query.doesNotMatchKeyInQuery(
            operation.field.value,
            operation.value.key,
            convertedValue
          );
          break;
      }
      return;
    }

    if (
      operation.operator === "containedIn" ||
      operation.operator === "notContainedIn"
    ) {
      let cValues = operation.value;
      if (operation.field.type === "pointer") {
        cValues = (operation.value as ParsePointerRestType[]).map((v) => {
          return new Parse.Object(v.className, {
            objectId: v.objectId,
          });
        });
      }
      if (operation.field.type === "date") {
        cValues = (operation.value as ParseDateRestType[]).map((v) => {
          return dayjs(v.iso).toDate();
        });
      }
      query[operation.operator](operation.field.value, cValues);
      return;
    }

    if (
      operation.operator === "exists" ||
      operation.operator === "doesNotExist"
    ) {
      console.log("Operation: ", operation);
      query[operation.operator](operation.field.value);
      console.log("Query: ", query);
      return;
    }
    
    // handle all other operations
    (query[operation.operator] as CallableFunction)(
      operation.field.value,
      convertedValue
    );
  } catch (e) {
    console.warn("Invalid operation on query: ", operation.operator, e);
  }
}
